import React from 'react';

interface MediumIconProps {
  size?: number;
  className?: string;
}

/**
 * Medium brand glyph — the official three-ellipse "M" mark, drawn to its
 * correct proportions on a 24×24 grid so it stays crisp at any size. One solid
 * circle, one tall ellipse, and one thin ellipse. Monochrome via `currentColor`
 * so it inherits the surrounding text color and hover states.
 */
export const MediumIcon: React.FC<MediumIconProps> = ({ size = 20, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path d="M13.54 12a6.8 6.8 0 0 1-6.77 6.82A6.8 6.8 0 0 1 0 12a6.8 6.8 0 0 1 6.77-6.82A6.8 6.8 0 0 1 13.54 12zM20.96 12c0 3.54-1.51 6.42-3.38 6.42-1.87 0-3.39-2.88-3.39-6.42s1.52-6.42 3.39-6.42 3.38 2.88 3.38 6.42zM24 12c0 3.17-.53 5.75-1.19 5.75-.66 0-1.19-2.58-1.19-5.75s.53-5.75 1.19-5.75C23.47 6.25 24 8.83 24 12z" />
  </svg>
);

export default MediumIcon;
